import SearchBar from "../../components/Admin/Services/SearchBar";
import NavBarAdmin from "../../components/Admin/Layout/NavBarAdmin";
import MissionsAdminTable from "../../components/Admin/Table/MissionsAdminTable";
import { useEffect } from "react";
import { getAllMissions } from "../../services/Api/adminService";
import { useServiceStore } from "../../stores/admin/service";
import { useMissionStore } from "../../stores/admin/mission";
import { useParams } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import { ToastContainer } from "react-toastify";
import { showToastError } from "../../services/Toasts/toasts";

const AdminMission = () => {
  // Store
  const { update, searchTerm } = useServiceStore();
  const { missions, setMissions } = useMissionStore();
  const { idPartner } = useParams();

  useEffect(() => {
    if (searchTerm !== "") {
      const filteredRequests = missions.filter(
        (item: any) =>
          item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.CategoryMission?.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.UserToMissions.map((user: any) => user.User?.fullName)
            .join(" ")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
      setMissions(filteredRequests);
    } else {
      getAllMissions(Number(idPartner))
        .then((data) => setMissions(data))
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, [searchTerm, update]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <ToastContainer position="top-center" />

      <div className="w-full flex justify-start items-start">
        <NavBarAdmin />

        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <svg className="w-6 h-6 text-grey-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Liste des missions <span className="text-yellow-trio">({missions.length})</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez les missions
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Barre de recherche avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 mb-3 border border-gray-100">
            <div className="w-80">
              <SearchBar />
            </div>
          </div>

          {/* Table des missions avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <MissionsAdminTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminMission;
